import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { PHYSICAL_BLOTTER_FIELDS, SEARCH_PHYSICAL_BLOTTER_FIELDS } from '../../Models/BlotterTables';


export const PhysicalBlotter = () => {

    const config = SEARCH_PHYSICAL_BLOTTER_FIELDS

    const getPhysicalBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return PHYSICAL_BLOTTER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "physicalOrderNo":
                    minWidth = 160
                    break;
                case "transactionLocation":
                    minWidth = 160
                    break;
                case "settlementMethod":
                    minWidth = 150
                    break;
                case "physicalOrderDate":
                    minWidth = 160
                    break;
                case "requestedShipDate":
                    minWidth = 160
                    break;
                case "paymentPartner":
                    minWidth = 160
                    break;
                case "fulfillmentLocation":
                    minWidth = 160
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const PhysicalBlotterRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Physical Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getPhysicalBlotterColumns()} rows={PhysicalBlotterRows} />
        </div>
    )
}
